import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react'; // @ts-expect-error module is untyped

import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
// @ts-expect-error module is untyped
import { getAssetPageTypeI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { deployed } from '../../../utils/env';
import { getFullPublicThemesUrl } from '../../../utils/urls';
import { useUsedPageTypeValues } from '../../../hooks/useUsedPageTypeValues';
import AssetPageTypeUrls from '../../../constants/urls/AssetPageType';
import FilterSideNav from './FilterSideNav';

function usePageTypeOptions() {
  const pageTypeValues = useUsedPageTypeValues();
  const options = useMemo(() => {
    return pageTypeValues.map(value => ({
      text: unescapedText(getAssetPageTypeI18nKey(value)),
      value: value
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [pageTypeValues]);
  return options;
} // type guard for safely accessing AssetPageTypeUrls object


function isPageTypeUrlValue(value) {
  return value in AssetPageTypeUrls;
}

function usePageTypeNavOptions() {
  const options = usePageTypeOptions();
  const isDeployed = deployed();
  return options.reduce((navOptions, option) => {
    const {
      value: optionValue
    } = option;

    if (isPageTypeUrlValue(optionValue)) {
      const url = AssetPageTypeUrls[optionValue];
      navOptions.push(Object.assign({}, option, {
        href: `${getFullPublicThemesUrl('en', !isDeployed)}/${url}`
      }));
    }

    return navOptions;
  }, []);
}

function PageTypeNav({
  value
}) {
  const options = usePageTypeNavOptions();
  const activeValue = value.length === 1 ? value[0] : null;
  return /*#__PURE__*/_jsx(FilterSideNav, {
    "aria-label": unescapedText('marketplace-assets-ui.assets.filters.pageTypes.title'),
    name: ThemeQueryField.PAGE_TYPES,
    options: options,
    value: activeValue
  });
}

const PageTypeFilter = ({
  disabled,
  onChange,
  scrollable = true,
  value
}) => {
  const isPrerender = getIsPrerenderUserAgent();
  const options = usePageTypeOptions();
  return isPrerender ? /*#__PURE__*/_jsx(PageTypeNav, {
    value: value
  }) : /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.pageTypes.title'),
    disabled: disabled,
    multi: true,
    name: ThemeQueryField.PAGE_TYPES,
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    value: value
  });
};

export default PageTypeFilter;